import React from 'react';
import styles from '../TradeFlowTrackingTab.module.css';

export interface TabDefinition {
  number: number;
  label: string;
  shortLabel: string;
  description: string;
}

export const FLOW_TABS: TabDefinition[] = [
  {
    number: 1,
    label: 'Platform Fetch',
    shortLabel: 'Fetch',
    description: 'Ticker data fetched from exchanges',
  },
  {
    number: 2,
    label: 'Genesis Filters',
    shortLabel: 'Genesis',
    description: 'Volume, volatility, and spread filters',
  },
  {
    number: 3,
    label: 'Pipeline Filters',
    shortLabel: 'Pipeline',
    description: 'Technical, VWAP, session, structure, and regime filters',
  },
  {
    number: 4,
    label: 'XGBoost',
    shortLabel: 'XGBoost',
    description: 'ML model decision and score',
  },
  {
    number: 5,
    label: 'LightGBM',
    shortLabel: 'LGBM',
    description: 'Advanced leaf-wise ML decisions with 4H/OrderBook features',
  },
  {
    number: 6,
    label: 'Scoring & Gates',
    shortLabel: 'Scoring',
    description: 'Composite scoring and pre-pool entry gates',
  },
  {
    number: 7,
    label: 'Smart Pool',
    shortLabel: 'Smart',
    description: 'Top 50 ranked recommendations',
  },
  {
    number: 8,
    label: 'Active/Reserve',
    shortLabel: 'Pools',
    description: 'Active Pool (10) and Reserve Pool (5)',
  },
  {
    number: 9,
    label: 'Live Entry Gate v2',
    shortLabel: 'Live Gate',
    description: '23 real-time entry filters',
  },
  {
    number: 10,
    label: 'Technical Gate',
    shortLabel: 'Tech',
    description: 'RSI, MACD, EMA, Bollinger, ADX indicators',
  },
  {
    number: 11,
    label: 'Smart Sniper',
    shortLabel: 'Sniper',
    description: 'Entry timing optimization',
  },
  {
    number: 12,
    label: 'Execution',
    shortLabel: 'Exec',
    description: 'Job queue and trade outcomes',
  },
  {
    number: 13,
    label: 'Journey',
    shortLabel: 'Journey',
    description: 'Full symbol trade timeline',
  },
];

interface FlowTabBarProps {
  activeTab: number;
  onTabChange: (tab: number) => void;
}

const FlowTabBar: React.FC<FlowTabBarProps> = ({ activeTab, onTabChange }) => {
  return (
    <div className={styles.tabBar}>
      <div className={styles.tabBarTitle}>Trade Flow Tracking</div>
      <div className={styles.tabBarList}>
        {FLOW_TABS.map((tab) => (
          <button
            key={tab.number}
            className={`${styles.tabButton} ${
              activeTab === tab.number ? styles.tabButtonActive : ''
            }`}
            onClick={() => onTabChange(tab.number)}
            title={tab.description}
          >
            <span className={styles.tabNumber}>{tab.number}</span>
            <span className={styles.tabLabel}>{tab.shortLabel}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default FlowTabBar;
